// File: assets/oscar-quick-add.js
class OscarQuickAdd {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('oscar-quick-add')) {
        e.preventDefault();
        this.handleQuickAdd(e.target);
      }
    });
  }

  async handleQuickAdd(button) {
    const productHandle = button.dataset.productHandle;
    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      // Fetch product data
      const response = await fetch(`/products/${productHandle}.js`);
      const product = await response.json();

      // Add first variant to cart
      const cartResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: product.variants[0].id,
          quantity: 1
        })
      });

      if (cartResponse.ok) {
        this.showSuccess(button);
        this.updateCartCount();
        this.playOscarBark(); // Optional sound effect
      }
    } catch (error) {
      button.textContent = 'Error';
      setTimeout(() => {
        button.textContent = 'Quick Add';
        button.disabled = false;
      }, 2000);
    }
  }

  showSuccess(button) {
    button.textContent = 'Added! 🐾';
    button.style.background = '#4CAF50';

    // Create confetti effect
    this.createConfetti(button);

    setTimeout(() => {
      button.textContent = 'Quick Add';
      button.style.background = '';
      button.disabled = false;
    }, 2000);
  }

  createConfetti(button) {
    const rect = button.getBoundingClientRect();
    const confetti = document.createElement('div');
    confetti.className = 'oscar-confetti';
    confetti.style.left = rect.left + 'px';
    confetti.style.top = rect.top + 'px';
    document.body.appendChild(confetti);

    setTimeout(() => confetti.remove(), 1000);
  }

  async updateCartCount() {
    const cartData = await fetch('/cart.js').then(r => r.json());
    const cartCount = document.querySelector('.cart-count');
    if (cartCount) {
      cartCount.textContent = cartData.item_count;
      cartCount.classList.add('animate-bump');
      setTimeout(() => cartCount.classList.remove('animate-bump'), 300);
    }
  }

  playOscarBark() {
    // Optional: play sound effect if enabled in theme settings
    if (window.theme && window.theme.soundEffects) {
      const audio = new Audio('/assets/oscar-bark.mp3');
      audio.volume = 0.3;
      audio.play().catch(() => {}); // Silently fail if blocked
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new OscarQuickAdd());
} else {
  new OscarQuickAdd();
}
